import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
import Spacer from '../spacer';
const colors = {
  information: {
    icon: Colors.advanceBlue300,
    text: Colors.advanceBlue400
  },
  success: {
    icon: Colors.success300,
    text: Colors.success400
  },
  error: {
    icon: Colors.error300,
    text: Colors.error400
  },
  warning: {
    icon: Colors.warning300,
    text: Colors.warning400
  },
  neutral: {
    icon: Colors.gray100,
    text: Colors.gray200
  }
};

const icon = type => {
  switch (type) {
    case 'error':
    case 'warning':
      return 'cancel';

    case 'success':
      return 'check-circle';

    default:
      return 'pending';
  }
};

const StyledContainer = styled.View`
  height: 20px;
  border-radius: 20px;
  flex-direction: row;
  align-self: flex-start;
  align-items: center;
  padding: 0;
`;
export default function Status(props) {
  const type = Object.keys(colors).includes(props.type) ? props.type : Status.defaultProps.type;
  const iconType = props.icon === false ? false : props.icon || icon(type);
  return /*#__PURE__*/React.createElement(StyledContainer, null, iconType && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: iconType,
    color: colors[type].icon,
    size: 16
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    width: true
  })), /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "bold",
    color: colors[type].text
  }, props.children));
}
Status.defaultProps = {
  type: 'neutral',
  icon: '',
  children: ''
};
Status.propTypes = {
  type: PropTypes.oneOf(Object.keys(colors)),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map